document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener(
		'wpcf7submit',
		function (e) {
			const form = e.target
			const output = form.querySelector('.wpcf7-response-output')
			if (!output) return

			output.style.display = 'block'
			output.style.opacity = '1'
			output.style.transition = 'opacity 250ms ease'

			window.clearTimeout(form._cf7HideTimer)
			form._cf7HideTimer = window.setTimeout(() => {
				output.style.opacity = '0'
				window.setTimeout(() => {
					output.style.display = 'none'
				}, 260)
			}, 4000)
		},
		false,
	)

	document.addEventListener(
		'input',
		function (e) {
			const form = e.target.closest('form.wpcf7-form')
			if (!form) return

			const output = form.querySelector('.wpcf7-response-output')
			if (!output) return

			output.style.display = 'none'
		},
		true,
	)
})
